'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionMap = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.nuke = nuke;
exports.resourceActionCreators = resourceActionCreators;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _actionTypes = require('./actionTypes');

var types = _interopRequireWildcard(_actionTypes);

var _propType = require('./propType');

var _propType2 = _interopRequireDefault(_propType);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var actionMap = exports.actionMap = { fetch: 'get', create: 'post', update: 'put', destroy: 'delete' };

function urlAppend() {
  for (var _len = arguments.length, parts = Array(_len), _key = 0; _key < _len; _key++) {
    parts[_key] = arguments[_key];
  }

  var first = parts[0],
      rest = parts.slice(1);

  return rest.reduce(function (memo, str) {
    return memo.replace(/[^/]$/, '$&/') + str.replace(/^\/|\/$/g, '');
  }, first);
}

function nuke() {
  return { type: types.NUKE };
}

function resourceActionCreators(baseUrl, resourceName, definition) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (!definition) {
    throw new Error('Resource definition required');
  }

  var _definition$idAttribu = definition.idAttribute,
      idAttribute = _definition$idAttribu === undefined ? 'id' : _definition$idAttribu,
      url = definition.url,
      urlRoot = definition.urlRoot,
      rootParam = definition.rootParam;

  var agent = options.agent,
      before = options.before,
      rest = _objectWithoutProperties(options, ['agent', 'before']);

  if (!agent) agent = _axios2.default;

  if (!url && !urlRoot) {
    throw new Error('Invalid resource definition: Missing required field or function "url" or "urlRoot"');
  }

  var fn = function fn(memo, action) {
    var method = actionMap[action];

    var idUsed = false;
    function getResourceUrl() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      function getResult(val) {
        return typeof val === 'function' && val.call(definition, { data: data, method: method }) || val;
      }

      if (urlRoot) {
        var _part = getResult(urlRoot);
        var id = data[idAttribute];

        if (id === null || id === undefined) {
          return urlAppend(baseUrl, _part);
        }

        idUsed = true;
        return urlAppend(baseUrl, _part, encodeURIComponent(id));
      }

      var part = getResult(url);
      return urlAppend(baseUrl, part);
    }

    memo[action] = function (inputData) {
      if (inputData && inputData.nativeEvent) {
        inputData = undefined;
      }

      var requestUrl = getResourceUrl(inputData);

      var data = inputData;

      if (idUsed) {
        data = _extends({}, data);
        delete data[idAttribute];
      }

      if (method !== 'get' && (rootParam === true || typeof rootParam === 'string')) {
        var rootLabel = rootParam === true ? resourceName : rootParam;
        data = _defineProperty({}, rootLabel, data);
      }

      var config = _extends({}, rest, _defineProperty({
        url: requestUrl,
        method: method
      }, method === 'get' ? 'params' : 'data', data));

      if (before) {
        config = before(config) || config;
      }

      var payload = agent(config);

      return {
        type: types.REQUEST,
        payload: payload,
        meta: { action: action, method: method, url: requestUrl, resourceName: resourceName, inputData: inputData, definition: definition }
      };
    };

    return memo;
  };

  var resource = {
    reset: function reset(payload) {
      return {
        type: types.RESET,
        payload: payload,
        meta: { resourceName: resourceName, definition: definition }
      };
    },

    clearErrors: function clearErrors() {
      return { type: types.CLEAR_ERRORS, meta: { resourceName: resourceName } };
    },
    propType: _propType2.default
  };

  return Object.keys(actionMap).reduce(fn, resource);
}


//////////////////
// WEBPACK FOOTER
// ../dist/actionCreators.js
// module id = 321
// module chunks = 0